export default __webpack_public_path__ + "static/media/create.d430f9eb.svg";